'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.AppUserSchema = {
  title: 'AppUser',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/appUser.js
// module id = uNs9
// module chunks = 0